import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiService } from 'src/app/Services/api.service';

@Component({
    selector: 'app-orikanconfig',
    templateUrl: './orikanconfig.component.html',
    styleUrls: ['./orikanconfig.component.scss'],
    standalone: false
})
export class OrikanConfigComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiService, private parentRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { 
      this.ModelId = params['id']; 

      this.apiService.Get<any>("integrations/orikan/configuration/" + this.ModelId).then(result => {
        this.Model = result;
        this.StopLoading();
      });
    });
    
  }
}
